'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      border-bottom: 0;\n      background-color: transparent;\n      color: rgba(76, 76, 76, 0.5);\n      svg.icon {\n        color: rgba(76, 76, 76, 0.5);\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      color: white;\n      // background-color: ", ";\n\n      &:hover {\n        // background-color: ", ";\n        color: white;\n      }\n\n      &.active {\n        // background-color: ", ";\n        // border-bottom-color: white;\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n    \n      \n      color:", ";\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 18.2px;\n      padding: 28px 22px;\n    \n      &:hover {\n        background-color: ", ";\n        color: color:", ";\n      }\n    \n      &.active {\n        background-color: ", ";\n\n        height: 40px;\n      }\n    \n      @media (max-width: 1104px) {\n        font-size: 12px;\n        padding: 16px 22px;\n\n  \n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      border-bottom: 3px solid transparent;\n      padding-left: 16px;\n      padding-right: 16px;\n      .icon {\n        margin-right: 10px;\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  height: 100%;\n  text-decoration: none;\n  transition: background-color 0.3s, border-bottom-color 0.3s, color 0.3s;\n\n  &:hover,\n  &:focus {\n    text-decoration: none;\n  }\n\n  ", ";\n\n    ", ";\n    \n    \n\n  ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavLinkNative = exports.NavLink = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styled = require('../../../styled');

var _theme = require('../../../styled/theme');

var _theme2 = _interopRequireDefault(_theme);

var _reactRouterDom = require('react-router-dom');

var _place = require('../../../constants/place');

var _place2 = _interopRequireDefault(_place);

var _themes = require('../../../constants/themes');

var _themes2 = _interopRequireDefault(_themes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var NavLink = exports.NavLink = (0, _styledComponents2.default)(_reactRouterDom.NavLink)(_templateObject(), function (props) {
  return props.place === _place2.default.Header && _styledComponents.css(_templateObject2());
}, function (props) {
  return props.theme.name === _themes2.default.WHITE && _styledComponents.css(_templateObject3(), props.theme.HeaderBg, props.theme.gray, props.theme.notificationHover, props.theme.gray, props.theme.notificationHover);
}, function (props) {
  return props.theme.name === _themes2.default.BLACK && _styledComponents.css(_templateObject4(), _styled.colors.silver.darker, _styled.colors.brown.lite, _styled.colors.gray.lightness);
}, function (props) {
  return props.headerDisabled && _styledComponents.css(_templateObject5(), _theme2.default.gray);
});
var NavLinkNative = exports.NavLinkNative = NavLink.withComponent('a');